import { render, staticRenderFns } from "./TariffTable.vue?vue&type=template&id=2da6a21f&scoped=true&lang=pug&"
import script from "./TariffTable.vue?vue&type=script&lang=js&"
export * from "./TariffTable.vue?vue&type=script&lang=js&"
import style0 from "./TariffTable.vue?vue&type=style&index=0&id=2da6a21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da6a21f",
  null
  
)

export default component.exports